import { batch, useSignal } from "@preact/signals-react"
import { useCallback, useEffect } from "react"
import { getSubmit } from "@ui-seeker/utils"
import { BACKEND_APIS } from "@constants"
import { useToast } from "@hooks"

export default function useExportConnectionsTableData() {
	const data = useSignal([])
	const isLoading = useSignal(false)
	const { showToast } = useToast()

	const onGetData = useCallback(() => {
		isLoading.value = true
		getSubmit(`${BACKEND_APIS.MASTER_DATA}/admin/options/export-connections`)
			.then(res => batch(() => {
				data.value = res
				isLoading.value = false
			}))
			.catch(() => {
				isLoading.value = false
				showToast.error("Error retrieving data")
			})

	}, [])

	useEffect(() => {
		onGetData()
	}, [])

	return {
		data: data.value,
		isLoading: isLoading.value,
	}
}